/* eslint-disable import/no-anonymous-default-export */
import { SAVE_CONFIG } from "../actionTypes/config";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case SAVE_CONFIG: {
      const { data } = action;
      return data;
    }
    default:
      return state;
  }
}
